import useGlobalStore from "src/stores/useGlobalStore";
import { _forceLogout } from "./helpers/_forceLogout";

const forceLogout = async () => {
	await _forceLogout({
		apolloClient: useGlobalStore.getState().apolloClient ?? undefined,
	});
};
export default forceLogout;
